import {SankeyNode} from './sankey-node';
import SankeyPart from './sankey-part';
import {SerializedSankeyEdge} from './serialized';

export default class SankeyEdge extends SankeyPart {
  public fromNode: SankeyNode;
  public toNode: SankeyNode;

  constructor(serializedEdge: SerializedSankeyEdge) {
    super(serializedEdge);
  }

  get edgeId() {
    return `${this.fromNode.id}${this.toNode.id}`;
  }
}
